// extracted by mini-css-extract-plugin
export var active = "_l4-2";
export var recordingDot = "_l4-1";
export var recordingIndicator = "_l4-0";